import React from 'react';
import { setHOCDisplayName } from '@domain-group/fe-helper';
import GraphQLProvider from './graphql-provider';
import { jsx as ___EmotionJSX } from "@emotion/core";
var withGraphQLProvider = WrappedComponent => {
  var Hoc = props => ___EmotionJSX(GraphQLProvider, null, ___EmotionJSX(WrappedComponent, props));
  setHOCDisplayName(Hoc, WrappedComponent, 'graphqlProvider');
  return Hoc;
};
export default withGraphQLProvider;